ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}

window.moment = require '../../../../node_modules/moment/moment.js'
ProductReviews.Helpers = require '../../common/helpers'
ProductReviews.Views.UserReview = require '../views/product_reviews_user_review'

ProductReviews.Model = Backbone.Model.extend
  idAttribute: 'uuid'
  defaults:
    rating: 0

  initialize: (attrs, options) ->
    @set 'locale', I18n.locale
    _.extend this, options
    _.bindAll this, 'reviewSuccess', 'reviewError', 'upvoteSuccess', 'upvoteError', 'unvoteSuccess', 'unvoteError', 'deleteSuccess', 'deleteError'

  url: (action = '') ->
    "#{@rootUrl}/product_review_proxy/reviews#{action}?_csrf=#{@csrf}"

  sync: (method, model, options = {}) ->
    options.timeout = ProductReviews.timeout
    Backbone.Model::sync.call this, method, model, options

  review: ->
    data =
      deal_uuid: @dealUuid
      locale: @get 'locale'
      rating: @get 'rating'
      text: $.trim @get('text')
    @save data,
      type: 'POST'
      wait: true
      success: @reviewSuccess
      error: @reviewError
      url: @url()

  reviewSuccess: (model, response) ->
    return @reviewError(model, response) if response.error?

    @displayOptions.userReviewIds.push response.review.uuid

    @set ProductReviews.Helpers.processUserReview response.review, @displayOptions, I18n, moment
    @view.showReviewSuccess(new ProductReviews.Views.UserReview model: this)

  reviewError: (model, response) ->
    @view.showReviewError()

  upvote: ->
    @save {},
      type: 'POST'
      wait: true
      success: @upvoteSuccess
      error: @upvoteError
      url: @url "/#{@id}/upvote"

  upvoteSuccess: (model, response) ->
    upvoteCount = @get('upvoteCount') + 1
    @set
      upvoteCount: upvoteCount
      helpfulUpvote:
        buttonClass: 'upvoted'
        buttonText: ProductReviews.Helpers.formatButtonText upvoteCount, true, @displayOptions, I18n
        text: ProductReviews.Helpers.formatHelpfulText upvoteCount, @displayOptions, I18n
    @collection.recordUpvote @id
    @view.showVoteSuccess this

  upvoteError: (model, response) ->
    return @upvoteSuccess(model, response) if @isDuplicateError(response)
    @set
      helpfulUpvote:
        buttonClass: ''
    @view.showVoteError this

  isDuplicateError: (response) ->
    (response.readyState is 4) and (response.status is 409)

  unvote: ->
    @save {},
      type: 'POST'
      wait: true
      success: @unvoteSuccess
      error: @unvoteError
      url: @url "/#{@id}/unvote"

  unvoteSuccess: (model, response) ->
    upvoteCount = if @get('upvoteCount') > 0 then @get('upvoteCount') - 1 else 0
    @set
      upvoteCount: upvoteCount
      helpfulUpvote:
        buttonClass: ''
        buttonText: ProductReviews.Helpers.formatButtonText upvoteCount, false, @displayOptions, I18n
        text: ProductReviews.Helpers.formatHelpfulText upvoteCount, @displayOptions, I18n
    @collection.recordUnvote @id
    @view.showVoteSuccess this

  unvoteError: (model, response) ->
    return @unvoteSuccess(model, response) if @isDuplicateError(response)
    @set
      helpfulUpvote:
        buttonClass: 'upvoted'
    @view.showVoteError this

  delete: ->
    @destroy
      wait: true
      success: @deleteSuccess
      error: @deleteError
      url: @url "/#{@id}"

  deleteSuccess: (response) ->
    @view.showDeleteSuccess this

  deleteError: (response) ->
    @view.showDeleteError this


module.exports = ProductReviews.Model
